import React from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { CheckCircle, Calendar, MessageCircle, FileText, ArrowRight } from 'lucide-react';
import { useAppContext } from '../contexts/AppContext';
export function BookingConfirmationScreen() {
  const navigate = useNavigate();
  const {
    bookingData
  } = useAppContext();
  return <div className="min-h-screen bg-brand-primary flex flex-col" data-id="element-135">
      <div className="flex-1 flex flex-col items-center justify-center p-6 text-center" data-id="element-136">
        <motion.div initial={{
        scale: 0,
        opacity: 0
      }} animate={{
        scale: 1,
        opacity: 1
      }} transition={{
        type: 'spring',
        stiffness: 200,
        damping: 20
      }} className="w-24 h-24 bg-white rounded-full flex items-center justify-center mb-6 shadow-lg" data-id="element-137">
          <CheckCircle size={48} className="text-status-success" data-id="element-138" />
        </motion.div>

        <motion.h1 initial={{
        y: 20,
        opacity: 0
      }} animate={{
        y: 0,
        opacity: 1
      }} transition={{
        delay: 0.2
      }} className="text-3xl font-bold text-white mb-2" data-id="element-139">
          Booking Confirmed!
        </motion.h1>

        <motion.p initial={{
        y: 20,
        opacity: 0
      }} animate={{
        y: 0,
        opacity: 1
      }} transition={{
        delay: 0.3
      }} className="text-brand-light mb-8" data-id="element-140">
          Appointment ID: #WHZ-849201
        </motion.p>

        <motion.div initial={{
        y: 30,
        opacity: 0
      }} animate={{
        y: 0,
        opacity: 1
      }} transition={{
        delay: 0.4
      }} className="w-full bg-white rounded-2xl p-6 text-left shadow-xl" data-id="element-141">
          <div className="flex items-center border-b border-ui-border pb-4 mb-4" data-id="element-142">
            <img src={bookingData?.professional?.image || 'https://via.placeholder.com/150'} alt="Doctor" className="w-12 h-12 rounded-full object-cover mr-4" data-id="element-143" />
            <div data-id="element-144">
              <h3 className="font-bold text-text-main" data-id="element-145">
                {bookingData?.professional?.name || 'Dr. Chinedu Okafor'}
              </h3>
              <p className="text-sm text-text-secondary" data-id="element-146">
                {bookingData?.careType || 'Video'} Consultation
              </p>
            </div>
          </div>

          <div className="space-y-3 mb-6" data-id="element-147">
            <div className="flex justify-between items-center" data-id="element-148">
              <span className="text-text-secondary text-sm" data-id="element-149">Date & Time</span>
              <span className="font-bold text-text-main text-sm" data-id="element-150">
                {bookingData?.date || 'Today'},{' '}
                {bookingData?.time || '02:30 PM'}
              </span>
            </div>
            <div className="flex justify-between items-center" data-id="element-151">
              <span className="text-text-secondary text-sm" data-id="element-152">Patient</span>
              <span className="font-bold text-text-main text-sm" data-id="element-153">
                Oluwaseun Adebayo
              </span>
            </div>
          </div>

          <div className="bg-brand-light p-4 rounded-xl mb-2" data-id="element-154">
            <h4 className="font-bold text-brand-dark text-sm mb-2" data-id="element-155">
              What happens next?
            </h4>
            <ul className="space-y-2 text-sm text-brand-dark/80" data-id="element-156">
              <li className="flex items-start" data-id="element-157">
                <div className="w-1.5 h-1.5 rounded-full bg-brand-primary mt-1.5 mr-2 shrink-0" data-id="element-158" />{' '}
                The professional has been notified.
              </li>
              <li className="flex items-start" data-id="element-159">
                <div className="w-1.5 h-1.5 rounded-full bg-brand-primary mt-1.5 mr-2 shrink-0" data-id="element-160" />{' '}
                You can chat with them immediately.
              </li>
              {bookingData?.careType === 'Video' && <li className="flex items-start" data-id="element-161">
                  <div className="w-1.5 h-1.5 rounded-full bg-brand-primary mt-1.5 mr-2 shrink-0" data-id="element-162" />{' '}
                  The video room opens 5 mins before start time.
                </li>}
            </ul>
          </div>
        </motion.div>
      </div>

      <motion.div initial={{
      y: 50,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} transition={{
      delay: 0.6
    }} className="p-6 bg-white rounded-t-[32px] space-y-3" data-id="element-163">
        <button onClick={() => navigate('/chat/active')} className="w-full bg-brand-primary text-white font-semibold py-4 rounded-xl shadow-md flex items-center justify-center active:scale-[0.98] transition-transform" data-id="element-164">
          <MessageCircle size={20} className="mr-2" data-id="element-165" /> Open Chat Now
        </button>

        <div className="grid grid-cols-2 gap-3" data-id="element-166">
          <button className="flex items-center justify-center py-3 border border-ui-border rounded-xl text-sm font-medium text-text-main active:bg-gray-50" data-id="element-167">
            <Calendar size={16} className="mr-2" data-id="element-168" /> Add to Calendar
          </button>
          <button className="flex items-center justify-center py-3 border border-ui-border rounded-xl text-sm font-medium text-text-main active:bg-gray-50" data-id="element-169">
            <FileText size={16} className="mr-2" data-id="element-170" /> View Receipt
          </button>
        </div>

        <button onClick={() => navigate('/home')} className="w-full py-3 text-text-secondary font-medium text-sm mt-2" data-id="element-171">
          Back to Home
        </button>
      </motion.div>
    </div>;
}